import type { FaireProductEntity } from "../../entity_types/product";

export const p_666jgtkf4a: FaireProductEntity = {
  token: "p_666jgtkf4a",
  type: "product",
  name: "Wholesale Love Letter Necklace -N185YG, N185RG, N185WG",
  brandToken: "b_867a2d82",
  brandName: "Linn.",
  imageUrl:
    "https://cdn.faire.com/fastly/7278a6a416fa71eb75b2e09660e58db491ccf55070017217da853cd99de056c4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abf64631a31fe7e3cd21bcd96d0c1b7f56acc8f6a6063ef9c3563aeae53f6923.jpeg",
    "https://cdn.faire.com/fastly/0b1eeabf9c3950356f4e22d50ec2e27efc333b0ce54a008d432a617b57eedf13.jpeg",
    "https://cdn.faire.com/fastly/8281b3333ccb5eabdcbffc19ac8722f0f1ddd55c642a7d318d59f31d1af5c11a.jpeg",
  ],
  priceDollars: 875,
  description:
    'Metal: 14k Recycled Gold\n\nSize: 7.5mm W x 22.87mm L\n\nJump Ring : 6mm\n\nStone: 1.25mm Ruby\n\nLength: 16"\n\nMade to order / 8 weeks to ship / Handcrafted in Brooklyn, NY\n',
  tags: [],
  msrpDollars: 1750,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:33.325Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
